import { Box,Table, TableBody, TableHead,TableContainer,TableCell,
    Pagination, TableRow, IconButton, Paper, Typography } from "@mui/material"
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import ModalEditDelete from './ModalCatalogs/ModalEditDelete';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';

function createData(id, customer, material, quantity, plant, crossReference, createdDate) {
   return {id, customer, material, quantity, plant, crossReference, createdDate}
 }
 
 const rowHeader = [
     "Id",
     "Province",
     "Plant",
     "Created Date", 
     "Edit", 
     "Delete"
 ]

const TableContentProvidences = ({offset, handleChange, pageSize, products, fetchData}) => {
    const [openModal, setOpenModal] = useState(false)
    const [tabValue, setTabValue] = useState(0)
	const [typeModel, setTypeModal] = useState("");
	const [province, setProvince] = useState(null);
    const handleOpenModalEdit = (row) => { setOpenModal(true); setTypeModal("Edit"); setProvince(row)}
	const handleOpenModalDelete = (row) => { setOpenModal(true); setTypeModal("Delete"); setProvince(row) }
    const handleCloseModal = () => { setOpenModal(false) }
    const handleChangeTap = (event, newValue) => { setTabValue(newValue) }

    const location = useLocation();
	const {  pathname } = location;


   return (
       <Box component="section" sx={{ margin: 5}}>
            <Typography variant="h4" sx={{textAlign:"center", marginBottom:"10px"}} color="primary">PROVINCES</Typography>
           <TableContainer component={Paper}>
           <Table sx={{ minWidth: 650 }} aria-label="simple table">
               <TableHead>
               <TableRow>
                   {rowHeader.map((row, index) =>(
                       <TableCell align="center" key={index}>{row}</TableCell>
                   ))}
               </TableRow>
               </TableHead>
               <TableBody>
               {products.map((row,index) => (
                   <TableRow
                   key={index}
                   sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                   >
                   <TableCell align="center" component="th" scope="row">
                       {row.id}
                   </TableCell>
                   <TableCell align="center">{row.province}</TableCell>
                   <TableCell align="center">{row.plant}</TableCell>
                   <TableCell align="center">{row.createdDate}</TableCell>
                   <TableCell align="center"><IconButton aria-label="edit" onClick={() => handleOpenModalEdit(row)}><EditIcon color="primary"/></IconButton></TableCell>
					<TableCell align="center"><IconButton aria-label="delete" onClick={() => handleOpenModalDelete(row)}><DeleteIcon color="error"/></IconButton></TableCell>
                   </TableRow>
               ))}
               </TableBody>
           </Table>
           </TableContainer>
           <Box display="flex" justifyContent="center" component="div" sx={{ marginTop: 5}}>
               <Pagination count={pageSize} page={offset+1} onChange={handleChange} />
           </Box>

           <ModalEditDelete 
                openModal={openModal}
                handleCloseModal={handleCloseModal}
                tabValue={tabValue} 
                handleChangeTap={handleChangeTap}
                pathname={pathname}
				typeModal={typeModel}
                productOject={province}
                fetchData={fetchData}
            />
       </Box>
   )
}

export default TableContentProvidences;